<template src="./gestioneNews.html"></template>

<script>
import DialogNews from "@/components/dialog/DettaglioNews.vue";
import { get_gestioneComunicazioni } from "@/api/api.dati.js";

import { get_idNews, delete_news } from "@/api/api.home.js";

import mixinNews from "@/utils/dati/mixinNews";

export default {
    components: { DialogNews },

    mixins: [mixinNews],

    data() {
        return {
            headerProps: {
                sortByText: "Ordina per",
            },
            page: 1,
            pageCount: 0,
            search: "",
            loadingTabella: false,
            dialogNews: false,

            datiNews: [],
            expanded: [],
            editedItem: {},

            idNews: null,
            isEdited: false,

            headersDati: [],

            selectedRow: null,
        };
    },

    methods: {
        async aggiungi() {
            this.isEdited = false;
            let par = {
                Username: this.utente,
            }
            let res = await get_idNews(par);
            this.idNews = res.data;
            this.dialogNews = true;
        },

        chiudiNews(value) {
            this.dialogNews = false;
            //if (value)
            this.refresh();
        },

        async caricaDati() {
            this.loadingTabella = true;
            let res = await get_gestioneComunicazioni();
            this.datiNews = res.data;
            this.loadingTabella = false;
        },

        refresh() {
            this.caricaDati();
        },

        editItem(item) {
            item.expanded = false;

            this.idNews = item.id;//.toString()
            this.editedItem = item;
            this.operazione = "Modifica elemento";
            this.isEdited = true;
            this.dialogNews = true;
        },

        async deleteItem(item) {
            let confirm = await this.$confirm.open("Elimina comunicazione n°" + item.id, "Vuoi eliminare la comunicazione: <b>" + item.titolo + "</b>?");
            if (!confirm) return;
            this.loadingTabella = true;
            let res = await delete_news(item.id);
            if (res.data == "OK") {
                this.refresh();
                if (item.id != 0) this.caricaDati();
                this.$toast.info("Comunicazione eliminata con successo!");
            } else this.$toast.alert("Impossibile eliminare la comunicazione!");

            this.loadingTabella = false;
        },

        parseData(data) {
            if (data.length == 0) return "";

            const [year, month, day] = data.split("-");
            return `${day.substring(0, 2)}/${month}/${year}`;
        },

        selectRow(i) {
            this.selectedRow = i;
        },
    },

    created() {
        if (this.role != "admin")
            this.$router.push({ path: "/" });
        this.headersDati = this.getHeadersTabella();
    },

    mounted() {
        this.caricaDati();
    },

    computed: {
        GetLoading() {
            return this.$store.getters["app/getLoading"];
        },

        utente() {
            return this.$store.getters["user/getNome"];
        },
        role() {
            return this.$store.getters['user/getRole'];
        },
    },
};
</script>